// Étape 16 — « Choisir dans mes leads » (premier champ des formulaires RDV / parcours)
import { useState, useEffect } from "react";
import { C, Btn, Input, Select, FormField, leadsV2Api, LEAD_SOURCES, leadStatutLabel, Badge } from "./shared";

export const LeadPicker = ({ lead, onPick, source, onSource, locked }) => {
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (lead || locked) return;
    const t = setTimeout(() => leadsV2Api.recherche(q).then(setRes).catch(() => setRes([])), 250);
    return () => clearTimeout(t);
  }, [q, lead, locked]);

  if (lead) {
    const i = lead.identite || {};
    return (
      <div data-testid="leadpicker-selected" style={{ background: C.goldlt, border: `1px solid ${C.gold}66`, borderRadius: 10, padding: "10px 14px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, marginBottom: 14 }}>
        <div>
          <div style={{ fontSize: 10, fontWeight: 700, color: C.golddm, textTransform: "uppercase", letterSpacing: ".07em" }}>Lead lié</div>
          <div style={{ fontSize: 14, fontWeight: 700, color: C.navy }}>{i.prenom} {i.nom} <Badge text={leadStatutLabel(lead)} /></div>
          <div style={{ fontSize: 11, color: C.mid }}>{[i.telephone, i.email].filter(Boolean).join(" · ")}</div>
        </div>
        {!locked && <Btn small onClick={() => onPick(null)} data-testid="leadpicker-clear">Changer</Btn>}
      </div>
    );
  }
  return (
    <div style={{ marginBottom: 14, position: "relative" }}>
      <FormField label="Choisir dans mes leads">
        <Input value={q} onChange={(e) => { setQ(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)}
          placeholder="Rechercher par nom, téléphone ou e-mail…" data-testid="leadpicker-search" />
      </FormField>
      {open && res.length > 0 && (
        <div data-testid="leadpicker-results" style={{ position: "absolute", left: 0, right: 0, top: "100%", zIndex: 20, background: "#fff", border: `1px solid ${C.border}`, borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,.08)", maxHeight: 240, overflowY: "auto" }}>
          {res.map(l => (
            <div key={l.id} onClick={() => { onPick(l); setOpen(false); }} data-testid={`leadpicker-item-${l.id}`}
              style={{ padding: "9px 14px", cursor: "pointer", borderBottom: `.5px solid ${C.border}`, fontSize: 13 }}>
              <strong style={{ color: C.navy }}>{l.prospect}</strong> <span style={{ fontSize: 11, color: C.mid }}>· {[l.identite?.telephone, l.identite?.email].filter(Boolean).join(" · ")} · {leadStatutLabel(l)}</span>
            </div>
          ))}
        </div>
      )}
      <div style={{ marginTop: 10 }}>
        <FormField label="Pas encore dans vos leads ? Source du prospect" required>
          <Select value={source || ""} onChange={(e) => onSource(e.target.value)} data-testid="leadpicker-source">
            <option value="">— Choisir la source —</option>
            {LEAD_SOURCES.map(s => <option key={s}>{s}</option>)}
          </Select>
        </FormField>
        <div style={{ fontSize: 11, color: C.muted, marginTop: 4 }}>Le lead sera créé automatiquement à l'enregistrement, avec contrôle des doublons.</div>
      </div>
    </div>
  );
};
